// @flow
import * as React from 'react';

import {
  ComposableTable,
  getTextCellGenerator,
  getButtonCellGenerator,
  getErrorCellGenerator,
  getErrorPercentageCellGenerator,
  getTimestampCellGenerator,
} from 'components/ComposableTable';
import Heading from 'components/Heading.jsx';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';

type Props = {
  previousSends: ?*,
  csvName: string,
};

export default class AdminAutoMessageDetailPreviousSendsTable extends React.Component<Props, void> {
  formatDataToRow = (previousSend: *) => {
    const {
      uuid,
      sentAt,
      readSummary: { recipientCount, failedCount }, // $FlowFixMe - this has not been done in apollo yet
      fileUpload: {
        studentIdList: { unmatchedStudentsCount },
      },
    } = previousSend.node;
    return {
      uuid,
      sentAt: new Date(sentAt),
      recipientCount,
      unmatchedStudentsCount,
      failedPercentage: failedCount / recipientCount,
    };
  };

  render() {
    const { previousSends, csvName } = this.props;
    const columnHeaders = ['Time sent', 'Recipients', 'Recipient errors', 'Delivery errors', ''];
    const columnGenerators = [
      getTimestampCellGenerator('sentAt'),
      getTextCellGenerator('recipientCount'),
      getErrorCellGenerator('unmatchedStudentsCount'),
      getErrorPercentageCellGenerator('failedPercentage'),
      getButtonCellGenerator({
        fieldForAction: 'uuid',
        // placeholder for real action
        onClickAction: () => undefined,
        buttonLabel: 'View details',
        buttonProps: { level: 'secondary', size: 'xsmall' },
      }),
    ];
    const sends = previousSends && previousSends.edges;
    const rows = sends ? sends.map(previousSend => this.formatDataToRow(previousSend)) : [];
    return (
      <React.Fragment>
        <Row size="small">
          <Heading level="4">Sent messages</Heading>
        </Row>
        <Row>
          <ComposableTable
            data-test="previous-sends-table"
            columnHeaders={columnHeaders}
            columnGenerators={columnGenerators}
            rows={rows}
            keyField="uuid"
          />
        </Row>
        {rows.length === 0 && (
          <Text align="center" element="div" size="small">
            <Row size="small">
              <Text weight="semibold">
                Once your auto message is live, it will be sent every time Remind receives a CSV
                {csvName && ` with the filename ${csvName}`}
              </Text>
            </Row>
            <Text color="thunder">Sent messages will appear here</Text>
          </Text>
        )}
      </React.Fragment>
    );
  }
}
